import { useEffect, useRef } from 'react'
import { cspEnforced } from '~/helpers/tracking/trackers/tagular'

/**
 * Reports each unique CSP violation once, using an allowed errorClass.
 */
export function useCSPViolationReporter(): void {
  const reported = useRef<Set<string>>(new Set())

  useEffect(() => {
    const handleViolation = (e: SecurityPolicyViolationEvent) => {
      const key = `${e.violatedDirective}|${e.blockedURI}`
      if (reported.current.has(key)) return
      reported.current.add(key)

      cspEnforced({
        errorMessage: `CSP violation: directive="${e.violatedDirective}" blocked="${e.blockedURI}"`,
        violatedDirective: e.violatedDirective,
        offendingSource: e.blockedURI,
      })
    }

    window.addEventListener('securitypolicyviolation', handleViolation)
    return () => {
      window.removeEventListener('securitypolicyviolation', handleViolation)
    }
  }, [])
}
